/*eslint-disable*/
import React , { useEffect, useState } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import Paper from '@material-ui/core/Paper';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import presentationStyle from "assets/jss/material-kit-pro-react/views/echosup/ReseauStyle.js";

import SectionFooter from "views/footer/PageFooter.js"

import biomedal from "assets/img/partenaires/BIOMEDAL.png";
import cit from "assets/img/partenaires/Cit-Formation.png";
import grandjean from "assets/img/partenaires/Ecole-Grandjean.png";
import ecosup_hotellerie from "assets/img/partenaires/ECOSUP-HOTELLERIE.png";
import ecosup_sante from "assets/img/partenaires/ECOSUP-SANTE.png";
import esgi from "assets/img/partenaires/ESGI.png";
import formasup from "assets/img/partenaires/FORMASUPCAMPUS.png";
import ican from "assets/img/partenaires/ICAN.png";
import cfi from "assets/img/partenaires/logo-cfi-formation.jpg";
import erudis from "assets/img/partenaires/logo-erudis-formation.jpg";
import ifc from "assets/img/partenaires/logo-ifc-loire.jpg";
import interior from "assets/img/partenaires/logo-interfor.jpg";

import fnep from "assets/img/partenaires/FNEP.png";
import fede from "assets/img/partenaires/FEDE.png";
import cosep from "assets/img/partenaires/COSEP.png";

import logo_esad from "assets/img/partenaires/logo-esad.jpg";
import logo_vidal_formation from "assets/img/partenaires/logo-vidal-formation.jpg";
import logo_ecole_dentaire_francaise from "assets/img/partenaires/logo-ecole-dentaire-francaise.jpg";
import logo_supveto from "assets/img/partenaires/logo-supveto.jpg";
import logo_aepe from "assets/img/partenaires/aepe.jpg";
import logo_prepa_vidal from "assets/img/partenaires/logo-prepa-vidal.jpg";
import logo_sple from "assets/img/partenaires/logo-sple.jpg";
import logo_ifd from "assets/img/partenaires/logo-ifd.jpg";
import logo_art_dance_international from "assets/img/partenaires/logo-art-dance-international.jpg";
import logo_epth from "assets/img/partenaires/logo-epth.jpg";
import logo_wibs from "assets/img/partenaires/logo-wibs.jpg";
import logo_formatives_network from "assets/img/partenaires/logo_formatives-network.png";
import logo_isv from "assets/img/partenaires/logo-isv.jpg";
import logo_esa_toulouse from "assets/img/partenaires/logo-esa-toulouse.jpg";
import logo_ecole_vidal from "assets/img/partenaires/logo-ecole-vidal.jpg";

// Kalysco network logos (in alphabetical order)
import logo_art_dance_international_kalysco from "assets/img/reseau/dance.png";
import logo_cefor from "assets/img/reseau/cefor.png";
import logo_cnrfp from "assets/img/reseau/cnrfp.png";
import logo_cpes from "assets/img/reseau/cpes.png";
import logo_ecoles_billieres from "assets/img/reseau/billieres.png";
import logo_ecoles_vidal_kalysco from "assets/img/reseau/ev.png";
import logo_ecosup_campus_kalysco from "assets/img/reseau/ecosup.png";
import logo_ecosup_toulon_kalysco from "assets/img/reseau/ecosup.png";
import logo_ecole_dentaire_francaise_kalysco from "assets/img/reseau/edf.png";
import logo_eforia from "assets/img/reseau/eforia.png";
import logo_esad_kalysco from "assets/img/reseau/esad.png";
import logo_esth from "assets/img/reseau/esth.png";
import logo_kalysco from "assets/img/reseau/kalysco.png";
import logo_palafis_kalysco from "assets/img/reseau/palafis.png";
import logo_prepa_vidal_kalysco from "assets/img/reseau/pv.png";
import logo_ruffel from "assets/img/reseau/ruffel.png";
import logo_sple_kalysco from "assets/img/reseau/sple.png";
import logo_supveto_kalysco from "assets/img/reseau/supveto.png";
import logo_vidal_formation_kalysco from "assets/img/reseau/vidal.png";              

const useStyles = makeStyles(presentationStyle);

export default function ReseauPage() {


  const classes = useStyles();
  return (
    <div>
      <Header
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 50,
          color: "white"
        }}
      />
      <Parallax
        image={require("assets/img/network.jpg")}
        className={classes.parallax}
        filter="dark"
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <GridContainer justifyContent="center" alignItems="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <h1 className={classes.titleTop}>
                      Kalysco, notre réseau d'écoles
                    </h1>
                  </GridItem>
                </GridContainer>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.section}>
          <div className={classes.container}>
            <GridContainer direction="row" justifyContent="center" alignItems="center" style={{ marginBottom: '40px' }}>
              <GridItem xs={12} sm={5} md={5}>
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={logo_kalysco} 
                    alt="Kalysco" 
                    className={classes.imgRounded + " " + classes.imgFluid}
                    style={{ maxWidth: '400px' }}
                  />
                </div>
              </GridItem>
              <GridItem xs={12} sm={7} md={7}>
                <h2 className={classes.title} style={{ textAlign: 'left', fontSize: '2.5rem', fontWeight: 'bold' }}>
                  La force d'un réseau national
                </h2>
                <br/>
              </GridItem>
            </GridContainer>
            <GridContainer direction="row" justifyContent="center" alignItems="center">
              <GridItem xs={12} sm={10} md={10}>
                <h3 className={classes.title}>Un ancrage national puissant</h3>
                <br/>
                <p className={classes.descriptionJustify} style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  Notre école fait partie d'un réseau d'écoles éthiques : <a href="https://www.kalysco.fr/" target="_blank" rel="noopener noreferrer" style={{ color: '#00acc1', textDecoration: 'none' }}><b>Kalysco</b></a>.
                </p>
                <p className={classes.descriptionJustify} style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  Le réseau <a href="https://www.kalysco.fr/" target="_blank" rel="noopener noreferrer" style={{ color: '#00acc1', textDecoration: 'none' }}><b>Kalysco</b></a> réunit des écoles indépendantes multi-formations, multi-secteurs et multi-sites au niveau national.
                </p>
                <p className={classes.descriptionJustify} style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  Écoles généralistes de Bac +2 à Bac +5, écoles spécialisées en santé, tourisme, langues ou encore danse… les formations dispensées sont nombreuses et complémentaires offrant ainsi un large éventail de possibilités facilitant les recherches dans son futur domaine de compétences.
                </p>
                <p className={classes.descriptionJustify} style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  Ce sont plus de <b>28 établissements</b> présents dans plus de <b>17 villes</b> qui accueillent, chaque année, environ 5000 apprenants en initial mais principalement en alternance.
                </p>
                <p className={classes.descriptionJustify} style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  Pendant de nombreuses années, la majorité des écoles qui composent le réseau ont travaillé côte à côte. L'objectif de ce rassemblement est qu'elles avancent maintenant ensemble afin de partager leurs savoirs, expertises, contenus et pratiques.
                </p>
                <p className={classes.descriptionJustify} style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  Véritable espace d'échange, de solidarité et de partage, <a href="https://www.kalysco.fr/" target="_blank" rel="noopener noreferrer" style={{ color: '#00acc1', textDecoration: 'none' }}><b>Kalysco</b></a> est construit autour de valeurs fortes, 3 piliers qui font la différence :
                </p>
                <ul className={classes.descriptionJustify} style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  <li><b>la bienveillance</b>, qui guide les actions, la façon d'enseigner et d'accompagner nos apprenants</li>
                  <li><b>la qualité des formations</b>, qui sont exigentes, innovantes et adaptées aux besoins de la société d'aujourd'hui et à celle de demain</li>
                  <li><b>la transparence</b> qui permet de bâtir des relations de confiance avec les apprenants, les équipes et les partenaires</li>
                </ul>
                <br/>
                <div style={{ textAlign: 'center', margin: '20px 0' }}>
                  <Button
                    color="info"
                    size="lg"
                    href="https://www.kalysco.fr/notre-charte-ethique"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ backgroundColor: '#00acc1', color: 'white' }}
                  >
                    Découvrez notre charte éthique
                  </Button>
                </div>
                <br/>
                {/* Vidéo Vimeo */}
                <div style={{ textAlign: 'center', margin: '40px 0' }}>
                  <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                    <iframe
                      src="https://player.vimeo.com/video/1093300171?h=031f9bb4b5"
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                      title="Présentation Kalysco"
                    ></iframe>
                  </div>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </div>

        <div className={classes.section}>
          <div className={classes.container}>
            <GridContainer direction="row" justifyContent="center" alignItems="center">
              <GridItem xs={12} sm={10} md={10}>
                <h3 className={classes.title}>La stabilité d'un réseau d'écoles</h3>
                <br/>
                <p className={classes.descriptionJustify} style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  S'inscrire dans une des écoles du réseau <a href="https://www.kalysco.fr/" target="_blank" rel="noopener noreferrer" style={{ color: '#00acc1', textDecoration: 'none' }}><b>Kalysco</b></a>, c'est s'assurer un avenir serein.
                </p>
                <p className={classes.descriptionJustify} style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  Depuis 1886, nos écoles grandissent, se modernisent et évoluent sans cesse. Des projets d'ouverture d'écoles sont en cours pour les mois à venir permettant ainsi de développer notre territoire d'expression et être au plus près des besoins de nos interlocuteurs.
                </p>
                <p className={classes.descriptionJustify} style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  Retrouvez ici nos <a href="https://www.kalysco.fr/nos-actualites" target="_blank" rel="noopener noreferrer" style={{ color: '#00acc1', textDecoration: 'none' }}><b>actualités</b></a>
                </p>
              </GridItem>
            </GridContainer>
          </div>
        </div>

        <div className={classes.section}>
          <div className={classes.container}>
            <GridContainer justifyContent="center" alignItems="center">
              <GridItem xs={12} sm={12} md={12}>
                <h3 className={classes.title} style={{ textAlign: 'center' }}>Les écoles adhérentes au réseau Kalysco</h3>
                <br/>
                <GridContainer justifyContent="center" alignItems="center" spacing={4}>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://www.artdance.fr/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_art_dance_international_kalysco} alt="Art Dance International" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://cefor.re/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_cefor} alt="CEFOR" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://cpes-ipress.com/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_cpes} alt="CPES" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://www.billieres.com/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_ecoles_billieres} alt="Ecoles Billières" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://www.ecoles-vidal.fr/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_ecoles_vidal_kalysco} alt="Ecoles Vidal" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://ecosup-campus.com/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_ecosup_campus_kalysco} alt="EcoSup Campus" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                </GridContainer>
                <br/>
                <GridContainer justifyContent="center" alignItems="center" spacing={4}>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://www.ecole-dentaire.fr/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_ecole_dentaire_francaise_kalysco} alt="Ecole Dentaire Française" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <img src={logo_eforia} alt="eforia" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://www.esad-dentaire.com/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_esad_kalysco} alt="ESAD" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://www.esth-toulouse.fr/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_esth} alt="ESTH" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://www.palafis.fr/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_palafis_kalysco} alt="Palafis" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                </GridContainer>
                <br/>
                <GridContainer justifyContent="center" alignItems="center" spacing={4}>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://prepavidal.com/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_prepa_vidal_kalysco} alt="PrépaVidal" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://www.ecoleruffel.com/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_ruffel} alt="Ruffel" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://www.sple.fr/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_sple_kalysco} alt="SPLE" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://supveto.com/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_supveto_kalysco} alt="Sup-Véto" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                  <GridItem xs={6} sm={4} md={2} style={{ padding: '10px', textAlign: 'center' }}>
                    <a href="https://vidal-formation.net/" target="_blank" rel="noopener noreferrer">
                      <img src={logo_vidal_formation_kalysco} alt="Vidal Formation" className={classes.imgRounded + " " + classes.imgFluid} style={{ maxWidth: '120px', height: 'auto' }} />
                    </a>
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
          </div>
        </div>

        <div className={classes.section}>
          <div className={classes.container}>
            <GridContainer justifyContent="center" alignItems="center">
              <GridItem xs={12} sm={5} md={5}>
                <h3 className={classes.title}>Partenaires institutionnels</h3>
                <p className={classes.descriptionJustify}>Les partenaires institutionnels jouent un rôle essentiel au sein de notre école. Engagés sur plusieurs années, ils soutiennent les différentes missions d'EcoSup dans leur globalité</p>
              </GridItem>
              <GridItem xs={12} sm={7} md={7}>
                <GridContainer justifyContent="center" alignItems="center">
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={fnep} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={fede} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={cosep} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
          </div>
          </div>
          <div className={classes.section}>
          <div className={classes.container}>
            <GridContainer justifyContent="center" alignItems="center">
              <GridItem xs={12} sm={5} md={5}>
                <h3 className={classes.title}>Ecoles partenaires</h3>
                <p className={classes.descriptionJustify}>EcoSup Toulon compte plus d'une douzaine d'école partenaire partout en France, proposant un panel de formation complet. </p>
              </GridItem>
              <GridItem xs={12} sm={7} md={7}>
                <GridContainer justifyContent="center" alignItems="center">
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={biomedal} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={cit} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={grandjean} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={ecosup_hotellerie} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer justifyContent="center" alignItems="center">
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={ecosup_sante} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={esgi} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={formasup} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={ican} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer justifyContent="center" alignItems="center">
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={cfi} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={erudis} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={ifc} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3}>
                    <img
                      src={interior} alt="..." className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>

      <SectionFooter/>
    </div>
  );
}